import React from "react";
import "./index.css";

const EmissionFactorWithUnit = ({
  value,
  onChange,
  units = [],
  placeholder = "0",
  defaultUnit = "kgCO₂/L",
  disabled = false,
}) => {
  // Parse the current value - it could be an object with manuel and unit, or just a number
  const currentManuel =
    value?.manuel !== undefined
      ? value.manuel
      : (typeof value === "object" ? value.value : value) || "";
  const currentUnit = value?.manuel_unit || value?.unit || defaultUnit;

  const handleManuelChange = (newManuel) => {
    onChange({
      manuel: newManuel,
      manuel_unit: currentUnit,
    });
  };

  const handleUnitChange = (newUnit) => {
    onChange({
      manuel: currentManuel,
      manuel_unit: newUnit,
    });
  };

  return (
    <div className="emission-factor-with-unit">
      <input
        type="number"
        step="0.0001"
        value={currentManuel}
        onChange={(e) => handleManuelChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="emission-factor-input"
      />
      <select
        value={currentUnit}
        onChange={(e) => handleUnitChange(e.target.value)}
        disabled={disabled}
        className="unit-dropdown"
      >
        {units.map((unit) => (
          <option key={unit.value} value={unit.value}>
            {unit.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EmissionFactorWithUnit;

